export default __webpack_public_path__ + "static/media/single-project-page-01-img21.b4864dca.jpg";